<i18n>
{
  "en": {
    "productMasterSearch": "Search by product master name"
  },
  "es": {
    "productMasterSearch":  "Buscar por nombre de product maestro"
  }
}
</i18n>
<template>
  <v-row>
    <v-col class="d-flex mt-lg-4 mt-md-4 ml-2 ml-md-5" cols="11">
      <v-text-field class="pt-0" height="42" :placeholder="$t('productMasterSearch')" :disabled="disabled" @input="onFinishTyping">
      </v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ProductMasterFilter extends Vue {
  @Prop({ type: Boolean, default: false }) disabled;

  onFinishTyping(emitted) {
    this.$emit('productMasterSearch', emitted);
  }
}
</script>
